import React from 'react';
import AgreementModal from './AgreementModal';
import { useAgreementCheck } from '../../hooks/useAgreementCheck';

const AgreementCheckpoint = ({ 
  trigger, 
  userType = 'buyer',
  triggerContext = {},
  onComplete, 
  onCancel,
  children 
}) => {
  const { requiresAcceptance, loading } = useAgreementCheck(trigger, userType);

  const handleAgreementComplete = () => {
    if (onComplete) {
      onComplete();
    }
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };

  // If loading, show spinner
  if (loading) {
    return (
      <div className="text-center p-4">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Checking agreements...</span>
        </div>
        <div className="mt-2">Checking required agreements...</div>
      </div>
    );
  }

  // If no agreements required, render children or complete
  if (!requiresAcceptance) {
    if (children) {
      return children;
    }
    if (onComplete) {
      onComplete();
    }
    return null;
  }

  // Show agreement modal
  return (
    <AgreementModal
      show={requiresAcceptance}
      onHide={handleCancel}
      trigger={trigger}
      userType={userType}
      triggerContext={triggerContext}
      onComplete={handleAgreementComplete}
    />
  );
};

export default AgreementCheckpoint;